export const SITE_URL = 'https://ktkadvisors.com';

export const CONTACT = {
  phone: '615-497-2166',
  phoneHref: 'tel:+16154972166',
  email: 'rselsor@ktkadvisors.com',
  emailHref: 'mailto:rselsor@ktkadvisors.com',
  address1: '1443 Lantana Drive',
  address2: 'Hoover, AL 35226',
  founder: 'Richard Selsor',
  founderTitle: 'Founder & CEO',
};

export const VIDEOS = {
  city: '/videos/city-night.mp4',
  gold: '/videos/gold-particles.mp4',
};

export const POSTERS = {
  city: '/images/poster-city.jpg',
  gold: '/images/poster-gold.jpg',
  laptop: '/images/poster-laptop.jpg',
};

export const IMG = {
  healthcare:
    'https://images.unsplash.com/photo-1587351021821-f871837248c6?crop=entropy&cs=srgb&fm=jpg&q=80&w=1400',
  healthcareAlt:
    'https://images.unsplash.com/photo-1764727291644-5dcb0b1a0375?crop=entropy&cs=srgb&fm=jpg&q=80&w=1400',
  benefits:
    'https://images.unsplash.com/photo-1560264280-88b68371db39?crop=entropy&cs=srgb&fm=jpg&q=80&w=1400',
  benefitsAlt:
    'https://images.unsplash.com/photo-1752650736164-d1e2358eb30b?crop=entropy&cs=srgb&fm=jpg&q=80&w=1400',
  technology:
    'https://images.unsplash.com/photo-1497215842964-222b430dc094?crop=entropy&cs=srgb&fm=jpg&q=80&w=1400',
  technologyAlt:
    'https://images.unsplash.com/photo-1631193816258-28b44b21e78b?crop=entropy&cs=srgb&fm=jpg&q=80&w=1400',
  shipping:
    'https://images.unsplash.com/photo-1553413077-190dd305871c?crop=entropy&cs=srgb&fm=jpg&q=80&w=1400',
  shippingAlt:
    'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?crop=entropy&cs=srgb&fm=jpg&q=80&w=1400',
  marketing:
    'https://images.unsplash.com/photo-1522071820081-009f0129c71c?crop=entropy&cs=srgb&fm=jpg&q=80&w=1400',
  marketingAlt:
    'https://images.unsplash.com/photo-1579389083046-e3df9c2b3325?crop=entropy&cs=srgb&fm=jpg&q=80&w=1400',
  meeting:
    'https://images.unsplash.com/photo-1573164574572-cb89e39749b4?crop=entropy&cs=srgb&fm=jpg&q=80&w=1400',
  meetingAlt:
    'https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?crop=entropy&cs=srgb&fm=jpg&q=80&w=1400',
  boardroom:
    'https://images.unsplash.com/photo-1542744173-8e7e53415bb0?crop=entropy&cs=srgb&fm=jpg&q=80&w=1400',
  executive:
    'https://images.unsplash.com/photo-1764810815228-b7f9432eec5c?crop=entropy&cs=srgb&fm=jpg&q=80&w=1400',
  skyline:
    'https://images.unsplash.com/photo-1496307653780-42ee777d4833?crop=entropy&cs=srgb&fm=jpg&q=80&w=1400',
};

export const SERVICES = [
  {
    slug: 'healthcare-revenue',
    num: '01',
    title: 'Healthcare Revenue & Billing',
    short: 'Strengthen billing, claims, and collections so your practice keeps more of the revenue it earns.',
    panel: 'Cleaner claims, disciplined follow-up, and fewer denials — a revenue cycle your team can rely on, with one point of contact.',
    image: 'https://images.unsplash.com/photo-1666886573531-48d2e3c2b684?crop=entropy&cs=srgb&fm=jpg&q=80&w=1400',
    imageAlt: 'Doctor and clinical staff reviewing records on a tablet',
    path: '/solutions/healthcare-revenue',
    cta: 'Discuss Your Revenue Cycle',
  },
  {
    slug: 'employee-benefits',
    num: '02',
    title: 'Employee Benefits & Wellness',
    short: 'Evaluate preventive care, virtual health, and wellness options alongside the benefits you offer today.',
    panel: 'A structured way to review benefits and wellness opportunities — including potential employer payroll savings where eligibility allows.',
    image: IMG.benefits,
    imageAlt: 'Open-plan office with natural light where employees work at desks',
    path: '/solutions/employee-benefits',
    cta: 'Explore Your Benefits Options',
  },
  {
    slug: 'technology-costs',
    num: '03',
    title: 'Technology Cost Optimization',
    short: 'Review software, telecom, and technology contracts to find overlap, waste, and room to negotiate.',
    panel: 'A clear line of sight from current spend to requirements, options, and implementation — without disrupting what already works.',
    image: 'https://images.unsplash.com/photo-1639066648921-82d4500abf1a?crop=entropy&cs=srgb&fm=jpg&q=80&w=1400',
    imageAlt: 'Rows of enterprise servers in a data center',
    path: '/solutions/technology-costs',
    cta: 'Review Your Technology Costs',
  },
  {
    slug: 'shipping-costs',
    num: '04',
    title: 'Shipping Cost Optimization',
    short: 'Audit carrier invoices, pursue eligible refunds, and bring real visibility to your shipping spend.',
    panel: 'From carrier contract analysis to invoice auditing and analytics — practical recovery for businesses that ship in volume.',
    image: IMG.shipping,
    imageAlt: 'Warehouse aisle filled with organized shipping inventory',
    path: '/solutions/shipping-costs',
    cta: 'Request a Shipping Cost Review',
  },
  {
    slug: 'ai-marketing',
    num: '05',
    title: 'AI Marketing & Business Growth',
    short: 'Bring marketing, lead generation, and follow-up together — coordinated and measured in plain business terms.',
    panel: 'AI-supported campaigns, content, and follow-up, coordinated end to end with performance visibility you can actually use.',
    image: IMG.marketing,
    imageAlt: 'Marketing team collaborating around a laptop',
    path: '/solutions/ai-marketing',
    cta: 'Discuss Your Growth Goals',
  },
];

export const INTEREST_OPTIONS = [
  { value: '', label: 'General consultation' },
  { value: 'healthcare-revenue', label: 'Healthcare Revenue & Billing' },
  { value: 'employee-benefits', label: 'Employee Benefits & Wellness' },
  { value: 'technology-costs', label: 'Technology Cost Optimization' },
  { value: 'shipping-costs', label: 'Shipping Cost Optimization' },
  { value: 'ai-marketing', label: 'AI Marketing & Business Growth' },
  { value: 'not-sure', label: "I'm not sure yet" },
];

export const CREDIBILITY = [
  '40+ Years of Business Experience',
  'Six Sigma Black Belt',
  'Personal, Consultative Guidance',
];

export const PROCESS_STEPS = [
  {
    n: '01',
    title: 'Understand',
    desc: 'Goals, challenges, current arrangements, and priorities — before any recommendation.',
  },
  {
    n: '02',
    title: 'Evaluate',
    desc: 'Review the relevant information and identify options genuinely worth considering.',
  },
  {
    n: '03',
    title: 'Coordinate',
    desc: 'Explain recommendations, commercial terms, and implementation requirements first.',
  },
  {
    n: '04',
    title: 'Review',
    desc: 'Assess outcomes and identify the appropriate next steps together.',
  },
];
